export default function PHP_str_pad() {
  return (
    <div>
      <h1>PHP_str_pad</h1>
    </div>
  );
}
